import { render, staticRenderFns } from "./BranchActions.vue?vue&type=template&id=6a20926b&"
import script from "./BranchActions.vue?vue&type=script&lang=js&"
export * from "./BranchActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports